<template>
  <el-container direction="vertical" style="margin: 5vh 5vw">
    <agent-new :isVisible.sync="showNewModal" />
    <agent-edit
      :isVisible.sync="showEditModal"
      :agentSelected="agentSelected"
    />

    <div class="header" style="margin-bottom: 25px">
      <h3>
        Agents
        <el-tooltip placement="right" effect="light">
          <span slot="content"
            >Agents are used to connect to a local PA instance<br />from DM.
          </span>
          <i
            class="el-icon-info"
            style="position: relative; left: 2px; bottom: 12px; font-size: 1rem"
          />
        </el-tooltip>
      </h3>
    </div>
    <el-table
      :data="items"
      :default-sort="{ prop: 'status', order: 'ascending' }"
      style="border: 2px solid #ebeef5; width: 100%"
      row-class-name="body-row"
    >
      <el-table-column v-if="userRole === 'Administrator'" width="200">
        <template slot="header">
          <el-button
            class="button"
            @click="showNewModal = true"
            icon="el-icon-plus"
            >Add Agent</el-button
          >
        </template>
        <template slot-scope="scope">
          <el-button-group>
            <el-tooltip placement="bottom" content="Edit Agent">
              <el-button
                size="medium"
                class="table-button"
                icon="el-icon-edit"
                @click="
                  agentSelected = scope.row;
                  showEditModal = !showEditModal;
                "
                @click.stop
            /></el-tooltip>
            <el-tooltip placement="bottom" content="Delete Agent">
              <el-button
                size="medium"
                class="table-button"
                icon="el-icon-delete"
                @click="deleteAgent(scope.row)"
                @click.stop
            /></el-tooltip>
            <el-tooltip placement="bottom" content="Download Agent">
              <el-button
                size="medium"
                class="table-button"
                icon="el-icon-download"
                @click="downloadAgent(scope.row)"
                @click.stop
            /></el-tooltip>
          </el-button-group>
        </template>
      </el-table-column>
      <el-table-column
        prop="name"
        label="Agent Name"
        sortable
        :min-width="40"
      />
      <el-table-column
        prop="status"
        label="Agent Status"
        sortable
        :min-width="40"
      />
      <el-table-column
        prop="envCount"
        label="Number of Environments"
        sortable
        :min-width="20"
      />
    </el-table>
  </el-container>
</template>
<script>
import AgentNew from "../components/modals/AgentNew.vue";
import AgentEdit from "../components/modals/AgentEdit.vue";
import AgentService from "../services/AgentService";
import { mapState } from "vuex";
import Helper from "../utilities/Helper";

export default {
  name: "Agent",
  data() {
    return {
      agentSelected: null,
      items: [],
      sortBy: "name",
      showNewModal: false,
      showEditModal: false,
    };
  },
  watch: {
    showEditModal(value) {
      if (!value) this.getAgents();
    },
    showNewModal(value) {
      if (!value) this.getAgents();
    },
  },
  components: { AgentNew, AgentEdit },
  computed: {
    ...mapState(["userId", "isUserLoggedIn", "organizationId", "userRole"]),
  },
  methods: {
    handleError: Helper.handleError,
    /**
     * Fetches current list of agents
     * @function
     */
    async getAgents() {
      const loading = this.$loading({
        lock: true,
        //text: "Working",
        background: "rgba(0, 0, 0, 0.3)",
      });
      try {
        const response = await AgentService.getAll({
          organizationId: this.organizationId,
        });
        this.items = response.data.agents;
      } catch (err) {
        this.handleError(err, this, this.instanceId);
      } finally {
        loading.close();
      }
    },
    async deleteAgent(item) {
      const input = prompt(
        `Are you sure you want to delete the "${item.name}" agent? All environments associated with this agent will be permanently deleted. Type the name of the agent to confirm.`
      );
      if (input === null) {
        return;
      } else if (input.toLowerCase() === item.name.toLowerCase()) {
        const loading = this.$loading({
          lock: true,
          //text: "Working",
          background: "rgba(0, 0, 0, 0.3)",
        });
        try {
          await AgentService.delete({
            id: item.id,
          });
          this.getAgents();
          this.$message({
            type: "success",
            message: `"${item.name}" agent deleted successfully`,
            duration: 5000,
            showClose: true,
          });
        } catch (err) {
          this.handleError(err, this, this.instanceId);
        } finally {
          loading.close();
        }
      } else {
        this.$message({
          type: "warning",
          message: "You must provide valid input to delete the agent.",
          duration: 7000,
          showClose: true,
        });
      }
    },
    async downloadAgent(item) {
      AgentService.download(item.id);
    },
  },
  async mounted() {
    if (!this.isUserLoggedIn) {
      this.$router.push({ name: "login" });
    } else {
      await this.getAgents();
    }
  },
};
</script>

<style scoped>
.header {
  display: flex;
  justify-content: space-between;
}
.error :deep(.el-input__inner) {
  border: 1px solid red;
  border-radius: 4px;
}
.button {
  background-color: #b3282d;
  color: white;
  border-color: white;
  padding: 10px 15px;
}
.button:focus {
  background-color: #9a0f14;
  color: white;
  border-color: white;
  outline: none;
}
.button:hover {
  background-color: #9a0f14;
  color: white;
  border-color: white;
  outline: none;
}
.table-button {
  background-color: inherit;
  color: #606266;
  border: none;
  outline: none;
  font-size: 1.15rem;
}
.table-button:focus {
  background-color: inherit;
  color: #606266;
  border: none;
  outline: none;
}
.table-button:hover {
  background-color: #ecf5fe;
  color: #606266;
  border: none;
  outline: none;
}
</style>